<template>
    <div class="gap-16 grid grid-cols-2">
        <div v-for="(item, key) in list" :key="item?.slug ?? key" class="group cursor-pointer">
            <template v-if="loading">
                <AspectRatio :ratio="2 / 1" class="flex flex-col justify-center items-center">
                    <Skeleton v-if="loading" class="w-full h-full" />
                    <div class="top-full left-full absolute w-1/2 max-w-44 -translate-x-5/6 -translate-y-5/6">
                        <AspectRatio :ratio="1 / 1">
                            <Glass v-gsap.magnetic.strong class="w-full h-full" content-class="flex-col items-center justify-center h-full">
                                <Skeleton class="size-16" />
                                <Skeleton class="mt-2 w-20 h-6" />
                            </Glass>
                        </AspectRatio>
                    </div>
                </AspectRatio>
            </template>
            <template v-else>
                <AspectRatio :ratio="2 / 1" class="flex flex-col justify-center items-center">
                    <NuxtLink :to="`/categories/${item.slug}`" class="block relative w-full h-full">
                        <div class="w-full h-full">
                            <Image :desktop="item.thumb" class="rounded-md w-full h-full" preset="lazyLoad" />
                        </div>
                        <div class="top-full left-full absolute w-1/2 max-w-44 -translate-x-5/6 -translate-y-5/6">
                            <AspectRatio :ratio="1 / 1">
                                <Glass v-gsap.magnetic.strong class="w-full h-full" content-class="flex-col items-center justify-center h-full">
                                    <Icon v-if="item.icon" :name="item.icon" class="size-16! text-primary" />
                                    <Typography tag="h3" variant="h5" class="mt-2 text-foreground">
                                        {{ $t(`category.name.${item.name}`, item.name) }}
                                    </Typography>
                                </Glass>
                            </AspectRatio>
                        </div>
                    </NuxtLink>
                </AspectRatio>
            </template>
        </div>
    </div>
</template>

<script lang="ts" setup>
import { AspectRatio } from "@/components/ui/aspect-ratio";
import { Glass } from "@/components/ui/glass";
import { Skeleton } from "@/components/ui/skeleton";

interface Props {
    list: APICategory[];
    loading?: boolean;
}

defineProps<Props>();
</script>

<style></style>
